import { AvailableOn } from '@app/types/movie';

export const getAvailableCinemas = (obj: AvailableOn): string[] => {
  return Object.keys(obj).filter((key) => obj[key]);
};
